import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { EventData } from '~admin/model/event-data';
import { mapEventData } from '~admin/model/event-data.mapper';
import { EventResponse } from '~client/model/admin/event-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetEventTask = OneArgTask<number, EventData>;

/**
 * Returns all details about an event
 * @param eventId
 */
export const performGetEvent = (eventId: number): Observable<EventResponse> =>
  apiClient.eventAdminController.getEvent$(eventId);

export const getEventTaskFactory = (): GetEventTask =>
  rxTask<number, EventData>((eventId: number) => performGetEvent(eventId).pipe(map(mapEventData)));



// WEBPACK FOOTER //
// ./interactor/event/perform-get-event.ts